/**
 * @generated SignedSource<<b4cccc86067dbc342f6f0b8d2d99875a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type useAuthPasswordResetMutation$variables = {
  email?: string | null;
};
export type useAuthPasswordResetMutation$data = {
  readonly passwordReset: {
    readonly ok: boolean | null;
  } | null;
};
export type useAuthPasswordResetMutation = {
  response: useAuthPasswordResetMutation$data;
  variables: useAuthPasswordResetMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "email"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "email",
        "variableName": "email"
      }
    ],
    "concreteType": "PasswordResetMutation",
    "kind": "LinkedField",
    "name": "passwordReset",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useAuthPasswordResetMutation",
    "selections": (v1/*: any*/),
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useAuthPasswordResetMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "78db6c9cb66df0d55ab9b0cd71476a24",
    "id": null,
    "metadata": {},
    "name": "useAuthPasswordResetMutation",
    "operationKind": "mutation",
    "text": "mutation useAuthPasswordResetMutation(\n  $email: String\n) {\n  passwordReset(email: $email) {\n    ok\n  }\n}\n"
  }
};
})();

(node as any).hash = "69117f6c6888887b74b8ba7224208141";

export default node;
